import { AssetExecutionStatus } from '@elementary/common-ui/services/gql/types';
import { ModelRun, ModelRuns } from '@elementary/common-ui/types';
import { ModelRunsTableAssetItem } from './types';

type ModelRunStatus = ModelRun['status'];

const EXECUTION_STATUS_TO_MODEL_RUN: Record<
  AssetExecutionStatus,
  ModelRunStatus
> = {
  SUCCESS: 'success',
  ERROR: 'error',
  SKIPPED: 'skipped',
};

const isAssetExecutionStatus = (
  value: string,
): value is AssetExecutionStatus => {
  const upper = value.toUpperCase();
  return upper === 'SUCCESS' || upper === 'ERROR' || upper === 'SKIPPED';
};

export const toModelRunStatus = (status: string): ModelRunStatus => {
  const upper = status.toUpperCase();
  return isAssetExecutionStatus(upper)
    ? EXECUTION_STATUS_TO_MODEL_RUN[upper]
    : 'skipped';
};

export const parseTableAssetToModelRuns = (
  asset: ModelRunsTableAssetItem,
): ModelRuns => ({
  unique_id: asset.id,
  database_name: asset.dbName,
  schema: asset.schemaName,
  name: asset.name,
  status: toModelRunStatus(asset.latestExecution?.status || ''),
  last_exec_time: asset.latestExecution?.executionTime ?? 0,
  median_exec_time: asset.performanceStats?.medianDuration ?? 0,
  exec_time_change_rate: asset.performanceStats?.changeRate ?? 0,
  totals: {
    errors: asset.performanceStats?.errorCount ?? 0,
    success: asset.performanceStats?.successCount ?? 0,
  },
  runs: [],
  last_generated_at: '',
  compiled_code: null,
  asset_metadata: {
    owners: asset.owners,
    tags: asset.tags,
    materialization: asset.materialization ?? undefined,
    subscribers: asset.subscribers,
    path: asset.path ?? undefined,
    is_critical: asset.isCritical,
  },
});
